module.exports = __webpack_public_path__ + "img/Cook.6119790c.png";